import React from 'react';
import styled from 'styled-components';

import { useOptionContext } from './option-context';

/** Weight / size label for an option tile (e.g. "3.5g", "1oz"). Hidden when only one option exists and no label is needed. */
export function TileLabel(): JSX.Element | null {
  const { label, shouldDisplayLabel } = useOptionContext();

  if (!shouldDisplayLabel) {
    return null;
  }

  return <Label>{label}</Label>;
}

const Label = styled.span`
  font-size: var(--cms-font-size, 12px);
  font-weight: var(--cms-font-weight, 400);
  line-height: 1;
`;
